module.exports = __webpack_public_path__ + "media/images/emoticons/flag-b8e8f605dfaf4512edca602e627ce1bf.gif";